<template>
  <v-container fill-height>
    <v-layout justify-center>
      <v-flex>
        <div class="breadcrumbs__wrapper">
          <span class="breadcrumbs__title">Usuarios</span>
          <v-btn class="white--text primary" to="/profile"
            ><v-icon left> mdi-plus</v-icon> AÑADIR</v-btn
          >
        </div>
        <v-divider class="mt-2"></v-divider>
        <!-- table Users -->
        <Table
          class="mt-10"
          :headers="this.headers"
          path="profile"
          collection="users"
          :values="this.getUsers"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Table from "@/components/Table.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "Users",
  components: {
    Table,
  },
  data() {
    return {
      search: "",
      headers: [
        {
          text: "Nombre",
          align: "start",
          filterable: true,
          value: "name",
        },
        { text: "Siglas", value: "sigla" },
        { text: "Dirección", value: "address" },
        { text: "Cargo", value: "post" },
        { text: "Email", value: "email" },
        { text: "Account Created", value: "creationDate" },
        { text: "Acciones", value: "actions", align: "center" },
      ],
      // desserts: [
      //   {
      //     name: "Rosen",
      //     surname: "Ivanov",
      //     email: "rosen@tram.es",
      //     password: "123456",
      //     sigla: 1,
      //     address: "La La Land 3",
      //     post: "Boss",
      //     creationDate: "10/10/2021",
      //   },
      //   {
      //     name: "Rosen",
      //     surname: "Ivanov",
      //     email: "rosen@tram.es",
      //     password: "123456",
      //     sigla: 1,
      //     address: "La La Land 3",
      //     post: "Boss",
      //     creationDate: "10/10/2021",
      //   },
      //   {
      //     name: "Rosen",
      //     surname: "Ivanov",
      //     email: "rosen@tram.es",
      //     password: "123456",
      //     sigla: 1,
      //     address: "La La Land 3",
      //     post: "Boss",
      //     creationDate: "10/10/2021",
      //   },
      //   {
      //     name: "Rosen",
      //     surname: "Ivanov",
      //     email: "rosen@tram.es",
      //     password: "123456",
      //     sigla: 1,
      //     address: "La La Land 3",
      //     post: "Boss",
      //     creationDate: "10/10/2021",
      //   },
      //   {
      //     name: "Rosen",
      //     surname: "Ivanov",
      //     email: "rosen@tram.es",
      //     password: "123456",
      //     sigla: 1,
      //     address: "La La Land 3",
      //     post: "Boss",
      //     creationDate: "10/10/2021",
      //   },
      // ],
    };
  },
  computed: {
    ...mapGetters(["getUsers"]),
  },
  methods: {
    ...mapActions(["getAllUsers"]),
  },
  created() {
    this.getAllUsers();
  },
};
</script>

<style scoped>
.breadcrumbs__wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.breadcrumbs__title {
  padding: 8px 0;
  border-bottom: 3px solid #008076;
}

.theme--light.v-btn.v-btn--has-bg {
  background: #1665d8;
}
</style>
